import { Box, styled } from '@ltvco/refresh-lib/theme';

export const SearchSettlementsCTAContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: isMobile ? theme.spacing(2) : theme.spacing(2, 4),
  borderRadius: theme.spacing(1),
  margin: isMobile ? theme.spacing(0, 2, 2, 2) : theme.spacing(0, 0, 2, 0),
  backgroundColor: theme.palette.primary.light,
}));
